import { createFileRoute } from '@tanstack/react-router'
import { CeramicProtectionPage } from '../components/pages/CeramicProtectionPage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/ceramic-protection')({
  component: CeramicProtectionPage,
  head: () => publicPageHead({
    title: 'Ceramic Coating Bellarine & Geelong | Autoglow Detailing',
    description:
      'GYEON ceramic protection from the Drysdale studio, serving the Bellarine Peninsula and Geelong. Professional installation with safe preparation and a complimentary vehicle inspection.',
    path: '/ceramic-protection',
    ogDescription: 'GYEON ceramic protection at Autoglow in Drysdale, Geelong.',
  }),
})
